// extracted by mini-css-extract-plugin
export default {"container":"SignUp_container__NzZty"};